import React from "react"
import { Users, Heart } from "lucide-react"
import { INFLUENCER_MODE, INFLUENCER_ACCENT_COLOR } from "../constants"

/**
 * Toolbar segmented control - "All Influencers" vs "My Favourites"
 * (INFLUENCER_FAVOURITES_API.md §4). Sits beside InfluencerPlatformToggle,
 * same visual language (pill row, active state filled/bordered in the
 * section's pink accent) as that toggle - switching modes only changes
 * which endpoint InfluencerSection's data hook points at; every filter and
 * sort keeps working unchanged underneath it.
 */
const InfluencerModeToggle = ({ value, onChange, favouritesCount }) => {
  const options = [
    { id: INFLUENCER_MODE.ALL, label: "All Influencers", icon: Users },
    { id: INFLUENCER_MODE.FAVOURITES, label: "My Favourites", icon: Heart },
  ]

  return (
    <div style={{ display: "flex", gap: "4px", background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "10px", padding: "3px" }}>
      {options.map(({ id, label, icon: Icon }) => {
        const isActive = value === id
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            style={{
              display: "flex", alignItems: "center", gap: "6px",
              padding: "7px 12px", borderRadius: "8px",
              fontSize: "12.5px", fontWeight: 600, fontFamily: "Rubik",
              border: "none",
              background: isActive ? INFLUENCER_ACCENT_COLOR : "transparent",
              color: isActive ? "#fff" : "#9ca3af",
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "background 0.15s ease, color 0.15s ease",
            }}
          >
            <Icon size={13} fill={id === INFLUENCER_MODE.FAVOURITES && isActive ? "#fff" : "none"} />
            {label}
            {id === INFLUENCER_MODE.FAVOURITES && favouritesCount > 0 && (
              <span style={{
                fontSize: "10.5px", fontWeight: 700,
                background: isActive ? "rgba(255,255,255,0.25)" : "rgba(255,255,255,0.08)",
                color: isActive ? "#fff" : "#9ca3af",
                padding: "1px 6px", borderRadius: "999px",
              }}>
                {favouritesCount}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default InfluencerModeToggle
